import { ExamplesPayload } from '~/common/types/types';
import { TechnologyName } from '~/common/enums/enums';
import hypeCrafter from '~/assets/img/project-examples/hype-crafter.gif';
import perflow from '~/assets/img/project-examples/perflow.gif';
import resumeGemm from '~/assets/img/project-examples/resume-gemm.gif';

const examplesPayload: ExamplesPayload = {
  title: 'technology.qa.examples.title',
  techListTitle: 'technology.qa.examples.techListTitle',
  items: [
    {
      title: 'technology.qa.examples.group0.title',
      description: 'technology.qa.examples.group0.description',
      imgPath: hypeCrafter,
      imgBackgroundColor: '#00ADEE',
      technologies: [
        TechnologyName.TYPESCRIPT,
        TechnologyName.NEXT_JS,
        TechnologyName.REDUX,
        TechnologyName.NODEJS,
        TechnologyName.AWS,
        TechnologyName.POSTGRESQL,
        TechnologyName.PRISMA,
        TechnologyName.REDIS,
      ],
    },
    {
      title: 'technology.qa.examples.group1.title',
      description: 'technology.qa.examples.group1.description',
      imgPath: perflow,
      imgBackgroundColor: '#5F3E94',
      technologies: [
        TechnologyName.TYPESCRIPT,
        TechnologyName.ANGULAR,
        TechnologyName.DOT_NET,
        TechnologyName.MS_SQL,
        TechnologyName.DOCKER,
        TechnologyName.SIGNAL_R,
        TechnologyName.RABBIT_MQ,
        TechnologyName.FLUTTER,
      ],
    },
    {
      title: 'technology.qa.examples.group2.title',
      description: 'technology.qa.examples.group2.description',
      imgPath: resumeGemm,
      imgBackgroundColor: '#425373',
      technologies: [
        TechnologyName.TYPESCRIPT,
        TechnologyName.REACT,
        TechnologyName.REDUX,
        TechnologyName.NODEJS,
        TechnologyName.FASTIFY,
        TechnologyName.POSTGRESQL,
        TechnologyName.OPEN_AI,
        TechnologyName.AWS,
      ],
    },
  ],
};

export { examplesPayload };
